// removed by extract-text-webpack-plugin
module.exports = {"contact_detail":"_2GpD4QZyGt9jXRWUcZIoGF","single_contact_header":"VvqEvejoAp4MG8RJS7-Pq","contact_view_image":"_1ErnB2UveKn7uNCML9t_E-","contact_view_headline_container":"_1wWL4eC4WEiJKyu74jvHOa","contact_view_headline":"LgaSx-uhjuzjrU0BkDws3","contact_view_value":"_2WWDIK-GW7OL1gGLDbq4mD","action_buttons":"bOaJ6-zHWFo-T1GcBNYpj"};


//////////////////
// WEBPACK FOOTER
// ./components/elements/contactview/style.less
// module id = 63
// module chunks = 0